import { Link } from 'react-router-dom';
import { ClassNameProps } from '../../../types/types';
const Login: React.FC<ClassNameProps> = ({ className }) => {
  return (
    <Link to='https://my.contactpay.com/auth/login' className={className}>
      <span className='login__text text-menu'>Log&nbsp;in</span>
    </Link>
  );
};
export default Login;
